import PropTypes from 'prop-types';

const propTypes = {
  homeTeamShield: PropTypes.string,
  visitorColumns: PropTypes.string,
  columns: PropTypes.array,
  title: PropTypes.string,
  directStats: PropTypes.object,
  homeTeam: PropTypes.object,
  awayTeam: PropTypes.object,
  eventsFailed: PropTypes.bool,
  tabletMode: PropTypes.bool,
};

const defaultProps = {
  homeTeamShield: '',
  visitorColumns: '',
  columns: [],
  title: '',
  directStats: {},
  homeTeam: null,
  awayTeam: null,
  eventsFailed: false,
  tabletMode: false,
};

export { propTypes, defaultProps };
